import {Suspense, useEffect, useState} from 'react';

import {ErrorBoundary} from 'app/core/errorHandler/errorBoundary';
import {appEvents} from 'app/utils/appEvents';
import {ComponentPortal} from 'app/utils/initialize/components/componentPortal';
import {type ComponentMountDataTransporter, type WebComponentUnmountDataTransporter} from 'app/utils/initialize/interface';

export const GemInitializeWebComponents = () => {
    const [webComponentDataTransporterItems, setWebComponentDataTransporterItems] = useState<ComponentMountDataTransporter[]>([]);

    useEffect(() => {
        const handleWebComponentMount = (event: Event) => {
            const customEvent = event as CustomEvent<ComponentMountDataTransporter>;
            setWebComponentDataTransporterItems((prevItems) => {
                return [...prevItems, customEvent.detail];
            });
        };

        const handleWebComponentUnmount = (event: Event) => {
            setWebComponentDataTransporterItems(getUpdateStateFn(event as CustomEvent<WebComponentUnmountDataTransporter>));
        };

        document.addEventListener(appEvents.webComponentMount, handleWebComponentMount);
        document.addEventListener(appEvents.webComponentUnmount, handleWebComponentUnmount);
        return () => {
            document.removeEventListener(appEvents.webComponentMount, handleWebComponentMount);
            document.removeEventListener(appEvents.webComponentUnmount, handleWebComponentUnmount);
        };
    }, []);

    return webComponentDataTransporterItems.map((item) => {
        return (
            <ErrorBoundary msg="" key={item.key}>
                <ComponentPortal element={item.element} removeContent={item.removePortalContent}>
                    <Suspense>
                        <item.ReactLazyComponent config={item.config} element={item.element} />
                    </Suspense>
                </ComponentPortal>
            </ErrorBoundary>
        );
    });
};

const getUpdateStateFn = (event: CustomEvent<WebComponentUnmountDataTransporter>) => (prevItems: ComponentMountDataTransporter[]) => {
    return prevItems.filter((item) => item.key !== event.detail.key);
};
